
import ReactEChartsCore from "echarts-for-react/lib/core"
import * as echarts from 'echarts/core';
import { HeatmapChart, BarChart, PieChart, LineChart } from "echarts/charts";
import { TooltipComponent, GridComponent, VisualMapComponent, LegendComponent, TitleComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { LabelLayout } from 'echarts/features';

export function Piechart(props) {
    echarts.use([
      TitleComponent,
      TooltipComponent,
      LegendComponent,
      PieChart,
      CanvasRenderer,
      LabelLayout
    ]);

    const meta = props.meta || {};
    const chartData = Array.isArray(props.data) ? props.data : [];
    const showLegend = meta.showLegend !== false;
    const LEGEND_SCROLL_THRESHOLD = 20;
    const useLegendScrollbar = showLegend && chartData.length > LEGEND_SCROLL_THRESHOLD;
    const useNativeLegend = showLegend && !useLegendScrollbar;
    const chartHeight = `calc(${props.heightRatio}vh - 300px)`;
    const legendPanelMaxHeight = meta.legendPanelMaxHeight || 240;
    const legendPanelWidth = meta.legendPanelWidth || 128;
    const legendEdgePadding = meta.legendEdgePadding || 10;
    const colorPalette = [
      '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272',
      '#fc8452', '#9a60b4', '#ea7ccc', '#2f4554', '#61a0a8', '#d48265'
    ];
  
    const option = {
      tooltip: {
        trigger: 'item'
      },
      color: colorPalette,
      legend: useLegendScrollbar
        ? { show: false }
        : {
            orient: 'horizontal',
            left: 'center',
            bottom: legendEdgePadding,
            show: showLegend
          },
      title: {
        left: 'center',
        text: meta.title,
        show: meta.title ? true : false
      },
      series: [
        {
          name: meta.series || meta.title,
          type: 'pie',
            radius: useLegendScrollbar
              ? ['50%', '80%']
              : useNativeLegend
              ? ['44%', '72%']
              : ['40%', '70%'],
            center: useLegendScrollbar
              ? ['50%', '50%']
              : useNativeLegend
              ? ['50%', '43%']
              : ['50%', '50%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          data: chartData
        }
      ]
    };

    if (useLegendScrollbar) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', maxWidth: '100%' }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <ReactEChartsCore echarts={echarts} option={option} style={{ maxHeight: chartHeight, width: '100%' }} />
          </div>
          <div style={{ width: legendPanelWidth, flex: '0 0 auto', maxHeight: legendPanelMaxHeight, overflowY: 'auto', overflowX: 'hidden', paddingRight: legendEdgePadding, scrollbarWidth: 'thin' }}>
            {chartData.map((item, index) => (
              <div key={`${item.name}-${index}`} style={{ display: 'flex', alignItems: 'center', marginBottom: 6, fontSize: 11, lineHeight: 1.2 }}>
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: colorPalette[index % colorPalette.length],
                    marginRight: 6,
                    flexShrink: 0
                  }}
                />
                <span title={item.name} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {item.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      );
    }
  
    return <ReactEChartsCore echarts={echarts} option={option} style={{"maxHeight":chartHeight}} />;
  }

export function Barchart(props) {
    echarts.use([
      TitleComponent,
      GridComponent,
      BarChart,
      CanvasRenderer,
      TooltipComponent
    ]);
  
    const option = {
      tooltip: {
        position: 'top'
      },
      title: {
        left: 'center',
        text: props.meta.title,
        show: props.meta.title ? true : false
      },
      xAxis: {
        type: 'category',
        data: props.xAxisLabel
      },
      legend : {},
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: props.meta.series,
          data: props.data,
          type: 'bar'
        }
      ]
    };
  
    return <ReactEChartsCore echarts={echarts} option={option} style={{"maxHeight":`calc(${props.heightRatio}vh - 300px)`}} />;
  }

export function MultilineChart(props) {
  echarts.use([
    TitleComponent,
    GridComponent,
    LegendComponent,
    BarChart,
    LineChart,
    CanvasRenderer,
    TooltipComponent
  ]);

  var seriesArray = []
  var yAxisArray = []
  props.data.map((dataSet,index) => {
    yAxisArray.push({
      type: 'value',
      alignTicks: true,
      axisLabel: {
        formatter: dataSet.format
      }
    })
    seriesArray.push({
      name: dataSet.series,
      data: dataSet.data,
      type: dataSet.type,
      yAxisIndex: props.meta.differentY ? index : 0
    })
  })

  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        animation: false,
        label: {
          backgroundColor: '#505765'
        }
      }
    },
    legend : {},
    title: {
      left: 'center',
      text: props.meta.title,
      show: props.meta.title ? true : false
    },
    xAxis: {
      type: 'category',
      data: props.xAxisLabel
    },
    yAxis: yAxisArray,
    series: seriesArray
  };

  return <ReactEChartsCore echarts={echarts} option={option} style={{"maxHeight":`calc(${props.heightRatio}vh - 300px)`}} />;
}